import styled from 'styled-components'

import { helpers } from 'styles'

import { Content } from './Content'

export const HeaderIconWrapper = styled(Content)`
	align-items: center;
	justify-content: center;
	text-align: center;

	margin: ${helpers.spacing.small} -${helpers.spacing.large};
	padding: ${helpers.spacing.xxLarge} ${helpers.spacing.large};
	width: calc(100% + ${helpers.spacing.xxLarge});

	border-top: 1px solid ${helpers.color.border};
`
